// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import FormState from "@store/Framework/Store/Starter/Components/Form/FormState";
import { FormModel } from "@store/Framework/Store/Starter/Components/Form/FormTypes";
import { DestroyFormHandlerParameter } from "@store/Framework/Store/Starter/Components/Form/Handlers/DestroyForm";
import { SetFormHandlerParameter } from "@store/Framework/Store/Starter/Components/Form/Handlers/SetForm";
import { Draft } from "immer";

const initialState: FormState = {
    forms: [],
};

const actions = {
    "Starter/Components/Form/SetForm": (draft: Draft<FormState>, action: { parameter: SetFormHandlerParameter }) => {
        const newForm: FormModel = {
            hasAlreadyError: false,
            id: action.parameter.formId,
            inputs: [],
        };

        draft.forms = [...draft.forms, newForm];
    },
    "Starter/Components/Form/DestroyForm": (
        draft: Draft<FormState>,
        action: { parameter: DestroyFormHandlerParameter },
    ) => {
        const filteredFormsList = draft.forms.filter(x => x.id !== action.parameter.formId);
        draft.forms = filteredFormsList;
    },
    "Starter/Components/Form/SetInput": (draft: Draft<FormState>, action: { forms: FormModel[] }) => {
        draft.forms = action.forms;
    },
    "Starter/Components/Form/EmptyForm": (draft: Draft<FormState>, action: { forms: FormModel[] }) => {
        draft.forms = action.forms;
    },
};

const reducer = createTypedReducerWithImmer(initialState, actions);
export type FormActions = Parameters<typeof reducer>[1];
export default reducer;
